import React, {useEffect, useRef} from 'react';
import clsx from 'clsx';
import {HeaderActions} from "layouts/shared/header-actions/HeaderActions";
import logo from "../../../../assets/images/logo-rombo.png";
import logoMobile from "../../../../assets/images/logo.png";
import {useHome} from "../../HomeContext";
import {HeaderDrawerProvider, MobileDrawer} from "layouts/shared/mobile-drawer";

import styles from "./Header.module.scss";

export const Header = (props) => {
    const {bodyScrollTop} = useHome();
    const logoContainerRef = useRef();
    const isPassScrollBreakpoint = bodyScrollTop > 70;

    useEffect(
        (e) => {
            requestAnimationFrame(() => {
                if (isPassScrollBreakpoint) {
                    logoContainerRef.current.classList.add(styles.mobileLogoHeader);
                    return;
                }

                if (logoContainerRef.current.classList.contains(styles.mobileLogoHeader)) {
                    logoContainerRef.current.classList.remove(styles.mobileLogoHeader);
                }
            });
        },
        [bodyScrollTop],
    );

    return (
        <HeaderDrawerProvider>
            <header className={clsx("d-flex flex-row mb-0", styles.header, {[styles.mobileHeader]: isPassScrollBreakpoint})}>
                <div className={clsx(styles.logoImage)} ref={logoContainerRef}>
                    <img src={isPassScrollBreakpoint ? logoMobile : logo} alt="logo" className={styles.headerLogo} />
                    <MobileDrawer  {...props} />
                </div>

                <h3 className={styles.title}>ID AUTO REPORTES</h3>

                <div className={clsx("ml-auto border-0", styles.actions)}>
                    <nav className={clsx("navbar navbar-expand-sm flex-flex-d-center- h-full")}>
                        <HeaderActions {...props}/>
                    </nav>
                </div>
            </header>
        </HeaderDrawerProvider>
    );
};

export default Header;
